






































































import mixins from 'vue-typed-mixins'
import { LocalityValuationStepData } from '@/interfaces/valuation/ValuationData'
import * as types from '@/interfaces/valuation/types/LocalityValuationStep'
import valuationStepMixin from '@/mixins/valuation/valuationStep'
import LocalityDistrict from '@/components/valuation/locality/LocalityDistrict.vue'
import LocalityAddress from '@/components/valuation/locality/LocalityAddress.vue'
import LocalityGps from '@/components/valuation/locality/LocalityGps.vue'
import LocalityProject from '@/components/valuation/locality/LocalityProject.vue'
import {
  BuildingType,
  BuildingStatus,
} from '@/interfaces/valuation/types/BuildingValuationStep'

export default mixins(valuationStepMixin).extend({
  components: {
    LocalityDistrict,
    LocalityAddress,
    LocalityGps,
    LocalityProject,
  },
  data(): { stepData: LocalityValuationStepData; LocationType: any } {
    return {
      stepData: {
        locationType: types.LocationType.District,
        location: undefined,
      },
      LocationType: types.LocationType,
    }
  },
  computed: {
    buildingType(): BuildingType {
      return this.$store.getters['valuationProcess/buildingType']
    },
    buildingStatus(): BuildingStatus {
      return this.$store.getters['valuationProcess/buildingStatus']
    },
  },
  created() {
    if (
      this.buildingStatus !== BuildingStatus.Finished &&
      ![types.LocationType.GPS, types.LocationType.Project].includes(
        this.stepData.locationType
      )
    ) {
      this.stepData.locationType = types.LocationType.GPS
    }
  },
  methods: {
    setLocation(location: types.Location | undefined) {
      this.stepData = {
        locationType: this.stepData.locationType,
        location,
      }
    },
  },
})
